import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut, Home, Calendar, Users, Settings, Briefcase, Code, Terminal, Zap } from 'lucide-react'; // Added new icons

// ✅ CORRECTED PATH: AuthContext is now in client/src/, two levels up
import { useAuth } from '../../AuthContext'; 

// Component for Navigation Items (Updated to Dark Mode Styling)
const NavItem = ({ to, children, Icon }) => (
    <Link 
        to={to} 
        className="flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-teal-400 transition duration-150"
    >
        <Icon className="w-5 h-5" />
        <span className="hidden sm:inline">{children}</span>
    </Link>
);

const Navbar = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/'); // Redirect to the public home/landing page
    };

    // Simplify roles: In an MVP, we mostly care about 'admin' (the developer)
    const isAdmin = user && user.role === 'admin';
    
    // Determine the user's login status more simply for the MVP
    const isLoggedIn = !!user;

    return (
        // Dark theme navigation bar, fixed at the top
        <nav className="bg-gray-900 border-b border-teal-500 shadow-xl sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    
                    {/* Logo/Brand: Web3 MVP Name */}
                    <div className="flex items-center">
                        <Link 
                            to="/" 
                            className="flex-shrink-0 text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 tracking-wide"
                        >
                            DecentralizedDev MVP
                        </Link>
                    </div>

                    {/* Navigation Links */}
                    <div className="flex items-center space-x-1">
                        
                        {/* Always visible links (The MVP Core) */}
                        <NavItem to="/" Icon={Home}>Landing</NavItem>
                        <NavItem to="/dashboard" Icon={Zap}>Utility Dashboard</NavItem>
                        <NavItem to="/about" Icon={Code}>About</NavItem>
                        
                        {/* --- Conditional Links based on Role --- */}
                        
                        {/* Admin Specific Links (Developer Portal) */}
                        {isAdmin && (
                            <>
                                <NavItem to="/admin" Icon={Settings}>Admin Control</NavItem>
                                {/* Changed to inventory, reflecting data/config management */}
                                <NavItem to="/admin/inventory" Icon={Terminal}>Data Manager</NavItem>
                            </>
                        )}
                        
                        {/* --- Auth Status Links --- */}
                        {!isLoggedIn ? (
                            // Login button styled as a high-contrast action link
                            <NavItem 
                                to="/login" 
                                Icon={LogOut} 
                                className="!text-indigo-400 !hover:text-white !hover:bg-indigo-700 transition duration-150"
                            >
                                Dev Access
                            </NavItem>
                        ) : (
                            // Logout button is prominent and styled with the red accent
                            <button
                                onClick={handleLogout}
                                className="flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium text-white bg-red-600 hover:bg-red-700 transition duration-150 shadow-md"
                            >
                                <LogOut className="w-5 h-5" />
                                <span className="hidden sm:inline">Logout</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
